export enum LocalStorageKey {
  SessionToken = 'RPSApp.SessionToken',
  LastLoggedUserEmail = 'RPSApp.LastLoggedUserEmail',
  DocumentsViewMode = 'RPSApp.DocumentsViewMode',
  EventsViewMode = 'RPSApp.EventsViewMode'
}

export type DocumentsViewMode = 'list' | 'grid';
export type EventsViewMode = 'calendar' | 'list';

export const RENTAL_CAR_DETAIL_QUERY_KEY = ['rental', 'detail'];

export const DEFAULT_LANGUAGE = 'cs';
export const DEFAULT_COUNTRY = 'CZ';
export const DEFAULT_LOCALE = `${DEFAULT_LANGUAGE}-${DEFAULT_COUNTRY}`;
export const DEFAULT_CURRENCY = 'CZK';
